import { gql } from "apollo-angular";
import { DIF } from "./disclaimer-item"

export const SDF = gql`
  fragment SDF on StartDates {
    title
    header
    headerTag
    alignment
    showTerm
    hTagId
    backgroundColor {
      color
    }
    startDateSelection
    programId
    startDateItemsCollection {
      items {
        ...on StartDateItems {
            calendarDate
            startDateDescriptor
            applyByDate
        }
      }
    }
    content
    disclaimer {
      ... DIF
    }
  }
${DIF}`;
